export type { FullScreenUploadAreaProps } from './FullScreenUploadArea.types'
export { default as FullScreenUploadArea } from './FullScreenUploadArea'